/**
 * @fileoverview Model for an Apple configuration.
 *
 * @author Kuber Sethi (ksethi@yext.com)
 */

import {AppleCountryInfo} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/applecountryinfo';
import {LinkedAccount, LinkedAccountJson} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/linkedaccount';


export class AppleConfiguration {
  /**
   * @param {number} publisherId
   * @return {AppleConfiguration} */
  static initialConfiguration(publisherId) {
    return new AppleConfiguration({
      linkedAccount: undefined,
      appleCountryInfos: undefined,
      delegateAppleAccount: false,
      skipSetup: false,
      publisherId: publisherId,
    });
  }

  /**
   * @param {{
   *  linkedAccount: (LinkedAccount | undefined),
   *  appleCountryInfos: (Array<AppleCountryInfo> | undefined),
   *  delegateAppleAccount: boolean,
   *  skipSetup: boolean,
   *  publisherId: number,
   * }} params
   */
  constructor(params) {
    /** @type {LinkedAccount | undefined} */
    this.linkedAccount = params.linkedAccount;
    /** @type {Array<AppleCountryInfo> | undefined} */
    this.appleCountryInfos = params.appleCountryInfos;
    /** @type {boolean} */
    this.delegateAppleAccount = params.delegateAppleAccount;
    /** @type {boolean} */
    this.skipSetup = params.skipSetup;
    /** @type {number} */
    this.publisherId = params.publisherId;
  }

  /**
   * @return {!AppleConfigurationJson}
   */
  toJSON() {
    return {
      'linkedAccount': this.linkedAccount?.toJSON(),
      'appleCountryInfos': this.appleCountryInfos,
      'publisherId': this.publisherId,
    };
  }
}

/**
 * @dict
 * @typedef {{
 *  linkedAccount: (LinkedAccountJson | undefined),
 *  appleCountryInfos: (Array<AppleCountryInfo> | undefined),
 *  publisherId: (number | undefined),
 * }}
 */
export let AppleConfigurationJson;

export const AppleProductionPublisherId = 950;
export const AppleDQEPublisherId = 947;
const TEST_ACCOUNTS = ['514581'];
export const ApplePublisherId = TEST_ACCOUNTS.includes(window['businessId'])
  ? AppleDQEPublisherId
  : AppleProductionPublisherId;
